import { useResetPassword } from "@/api/auth";
import InventoZen from "@/components/icons/InventoZen.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import React from "react";
import { useTranslation } from "react-i18next";

interface ForgetPasswordMainProps {
  onNext: () => void;
  email: string;
  setEmail: (email: string) => void;
}

const ForgetPasswordMain = ({
  onNext,
  email,
  setEmail,
}: ForgetPasswordMainProps) => {
  const { t } = useTranslation();
  const urlWebsite = window.location.origin;
  const { mutate: resetPassword, isPending } = useResetPassword(email, urlWebsite);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    resetPassword(undefined, {
      onSuccess: () => onNext(),
    });
  };

  return (
    <div className="h-full flex items-center justify-center">
      <div className="m-auto w-[500px] h-fit p-10 bg-white rounded-lg shadow border border-slate-200 flex-col justify-start items-center gap-8 inline-flex">
        <div>
          <div className="justify-center items-center flex">
            <InventoZen />
          </div>
          <p className="text-center text-slate-900 text-3xl font-semibold font-['Instrument Sans'] leading-loose">
            {t("passwordForgotten")}
          </p>
          <p className="text-center text-[#475467] text-base font-['Instrument Sans']">
            {t("weWillSendYouALinkToResetYourPassword")}
          </p>
        </div>
        <form onSubmit={handleSubmit} className="w-full grid">
          <Input
            label={t("emailAddress")}
            id="email"
            type="email"
            placeholder={t("emailAddress")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            variant="ghost"
            disabled={isPending}
            className="mt-8 h-12 px-4 py-3 bg-[#008bd4] rounded-lg border border-[#006eab] justify-center items-center gap-1.5 inline-flex"
          >
            <div className="px-0.5 justify-center items-center flex">
              <p className="text-white text-base font-semibold font-['Raleway'] leading-normal">
                {t("sendALinkToResetYourPassword")}
              </p>
            </div>
          </Button>
          <a
            href="/"
            className="text-[#005d8d] text-sm font-semibold font-['Raleway'] text-center leading-normal mt-6"
          >
            {t("returnToLogin")}
          </a>
        </form>
      </div>
    </div>
  );
};

export default ForgetPasswordMain;
